import { ApiClient, resolveBaseUrl } from '@/api/client'
import { useAuthStore } from '@/auth/store'

export const API_BASE_URL = resolveBaseUrl(import.meta.env.VITE_API_BASE_URL)

/**
 * Client API de l'application : branché sur le store d'authentification pour
 * lire les jetons, enregistrer un rafraîchissement et couper la session quand
 * le rafraîchissement échoue.
 */
export const api = new ApiClient({
  baseUrl: API_BASE_URL,
  getAccessToken: () => useAuthStore.getState().accessToken,
  getRefreshToken: () => useAuthStore.getState().refreshToken,
  onSessionRefreshed: (session) => {
    useAuthStore.getState().setSession(session)
  },
  onAuthenticationLost: () => {
    useAuthStore.getState().signOut()
  },
})

export { ApiClient, buildQueryString, resolveBaseUrl } from '@/api/client'
export { ApiError, errorMessage } from '@/api/errors'
export type * from '@/api/types'
